import Vue from 'vue';
import {Component, Prop, PropSync, Watch} from 'vue-property-decorator';
import EstimateResult from "../shared/models/estimate-result.model";
import Helpers from "../shared/common/helpers";

@Component<LoadingEstimateComponent>({
  components: {
  },
  beforeRouteLeave (to, from, next) {
    next();
  },
})
export default class LoadingEstimateComponent extends Vue {

  @Prop() public estimateResult: EstimateResult;
  @Prop() public tripSearch: any;

  @PropSync('prop_estimateResultVM', {default: () => new EstimateResult()}) public estimateResultVM: EstimateResult; // The data that is used on the UI for the estimate result. Needed for animating the fares appearing one by one.

  public loadBarValue = 3;
  public estimatesLoaded: boolean = false;
  public tmpEstimateResult: EstimateResult; // Temporary object in which fares are removed before assigning it as a value for estimateResultVM
  public beforeUpdateEstimateResult: EstimateResult;  // Holds a full copy of the original estimate result, all fares.
  public estimateNextFareIdx = 0;

  @Watch('estimateResult', {immediate: true, deep: true})
  onEstimateResult(val: any, oldVal: any){
    this.estimatesLoaded = false;
    if(val && val.estimate && val.estimate.min && val.estimate.min.fares && val.estimate.min.fares.length){
      this.beforeUpdateEstimateResult = Helpers.clone(val);
      this.tmpEstimateResult = Helpers.clone(this.beforeUpdateEstimateResult);

      this.tmpEstimateResult.estimate.min.fares = [];
      this.tmpEstimateResult.estimate.max.fares = [];

      this.estimateResultVM = Helpers.clone(this.tmpEstimateResult);
      this.estimatesLoaded = false;

      let loadEstimatesInterval = setInterval(
        () => {
          let nextMinFaresIdx = this.estimateNextFareIdx;
          let nextMaxFaresIdx = this.estimateNextFareIdx;

          let nextMinFareIsAvailable = false;
          let nextMaxFareIsAvailable = false;

          // The following code uses airport codes returned by the estimates search
          // Useful if we want to display price ranges for each leg
          /*if(this.estimateResultVM.estimate.min.fares.length <= this.beforeUpdateEstimateResult.estimate.min.fares.length){
            nextMinFaresIdx = this.estimateResultVM.estimate.min.fares.length;
          }

          if(this.estimateResultVM.estimate.max.fares.length <= this.beforeUpdateEstimateResult.estimate.max.fares.length){
            nextMaxFaresIdx = this.estimateResultVM.estimate.max.fares.length;
          }

          if(this.beforeUpdateEstimateResult.estimate.min.fares[nextMinFaresIdx]){
            nextMinFareIsAvailable = true;
            this.estimateResultVM.estimate.min.fares.push(this.beforeUpdateEstimateResult.estimate.min.fares[nextMinFaresIdx]);
            //console.log(this.beforeUpdateEstimateResult.estimate.min.fares[nextMinFaresIdx]);
          } else {
            nextMinFareIsAvailable = false;
          }

          if(this.beforeUpdateEstimateResult.estimate.max.fares[nextMaxFaresIdx]){
            nextMaxFareIsAvailable = true;
            this.estimateResultVM.estimate.max.fares.push(this.beforeUpdateEstimateResult.estimate.max.fares[nextMaxFaresIdx]);
            //console.log(this.beforeUpdateEstimateResult.estimate.max.fares[nextMaxFaresIdx]);
          } else {
            nextMinFareIsAvailable = false;
          }*/

          /*if(this.estimateResultVM.estimate.min.fares.length <= this.tripSearch.itinerary.length){
            nextMinFaresIdx = this.estimateResultVM.estimate.min.fares.length;
          }

          if(this.estimateResultVM.estimate.max.fares.length <= this.tripSearch.itinerary.length){
            nextMaxFaresIdx = this.estimateResultVM.estimate.max.fares.length;
          }*/

          if(this.tripSearch.hasOwnProperty("itinerary")){
            const itin = this.tripSearch.itinerary;
            if(itin[nextMinFaresIdx] && itin[nextMinFaresIdx + 1]){
              nextMinFareIsAvailable = true;
              nextMaxFareIsAvailable = true;
              if(itin[nextMinFaresIdx].byland != "1"){
                let from = itin[nextMinFaresIdx].city;
                let to = itin[nextMinFaresIdx + 1].city;
                let route = from + '-' + to;
                let fare: any = {
                  cost: '-',
                  fallback: '0',
                  price: '-',
                  route: route
                };
                this.estimateResultVM.estimate.min.fares.push(fare);
                this.estimateResultVM.estimate.max.fares.push(fare);
              }
              this.estimateNextFareIdx++;
            } else {
              nextMinFareIsAvailable = false;
              nextMaxFareIsAvailable = false;
            }
          }

          if(nextMinFareIsAvailable == false && nextMaxFareIsAvailable == false){
            this.estimateResultVM.estimate.min.price = this.beforeUpdateEstimateResult.estimate.min.price;
            this.estimateResultVM.estimate.max.price = this.beforeUpdateEstimateResult.estimate.max.price;
            this.estimatesLoaded = true;
            clearInterval(loadEstimatesInterval);
          }
        },
        900
      );
    }
  };

  constructor(){
    super();
  }

  mounted(){
    this.$bvModal.show('loading-estimate');
    this.startAutoProgressIndicator();
  }

  getRoutePairs(strRoute: string): Array<RoutePair>{
    let routePairs: Array<RoutePair> = [];
    let parts = strRoute.split('-');
    let newPair = new RoutePair();
    // Show Hubs
    /*for(let part of parts){
      if(newPair.start != ""){
        newPair.destination = part;
        let clone = JSON.parse(JSON.stringify(newPair));
        routePairs.push(clone);
        newPair = new RoutePair;
      } else {
        newPair.start = part;
      }
    }*/
    // Do not show Hubs
    newPair.start = parts[0];
    newPair.destination = parts[parts.length - 1];
    routePairs.push(newPair);
    return routePairs;
  }

  startAutoProgressIndicator(){
    let loaderInterval = setInterval(
      (() => {
        let incrementVal:number = 1;
        if(this.loadBarValue < 18){
          incrementVal = 3;
        } else if(this.loadBarValue < 30){
          incrementVal = 2;
        } else if(this.loadBarValue < 81) {
          incrementVal = 1;
        } else if(this.loadBarValue < 90) {
          incrementVal = 0.5;
        } else if(this.loadBarValue < 95) {
          incrementVal = 0.3;
        } else {
          incrementVal = 0.1;
        }
        if(this.loadBarValue < 100 && this.loadBarValue + incrementVal <= 99.9) {
          this.loadBarValue = this.loadBarValue + incrementVal;
        } else {
          this.loadBarValue = 99.9
        }
        if(this.loadBarValue == 99.9){
          clearInterval(loaderInterval);
        }
      }),
      1000
    );
  }
}


class RoutePair {
  public start: string = "";
  public destination: string = "";
  public toJson(){
    return {
      start: this.start,
      destination: this.destination
    }
  }
}
